// src/pages/admin/CustomerHistoryModal.js
import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, CircularProgress, Alert, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import api from '../../api/index.js';

const style = { 
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800, // Ancho ajustado
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    maxHeight: '90vh',
    overflowY: 'auto' };

const CustomerHistoryModal = ({ open, onClose, customer }) => {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchHistory = async () => {
            if (customer?.id) {
                setLoading(true);
                setError('');
                try {
                    const response = await api.get(`/customers/${customer.id}/history`);
                    setHistory(response.data);
                } catch (err) {
                    setError('No se pudo cargar el historial.');
                } finally {
                    setLoading(false);
                }
            }
        };
        if (open) {
            fetchHistory();
        }
    }, [open, customer]);

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={style}>
                <Typography variant="h6" gutterBottom>
                    Historial de Transacciones de: {customer?.name}
                </Typography>

                {loading ? <CircularProgress /> : error ? <Alert severity="error">{error}</Alert> : (
                    <TableContainer component={Paper}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Fecha</TableCell>
                                    <TableCell>Tipo</TableCell>
                                    <TableCell align="right">Monto</TableCell>
                                    <TableCell align="right">Saldo Resultante</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {history.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{new Date(row.date).toLocaleString()}</TableCell>
                                        <TableCell>{row.type}</TableCell>
                                        <TableCell align="right" sx={{ color: row.amount > 0 ? 'error.main' : 'success.main' }}>
                                            {`$${Number(row.amount).toFixed(2)}`}
                                        </TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                                            {`$${Number(row.balance).toFixed(2)}`}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Box>
        </Modal>
    );
};

export default CustomerHistoryModal;
